/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from './../request.js'

export function smartStopList(params){
    return request({
        url: 'smartStop/list.do?',
        method: 'post',
        data:params
    })
}
export function batchStop(params){
    return request({
        url: 'smartStop/batchStopSync.do?',
        method: 'post',
        data:params,
        timeout:20000,
		headers:{'Content-Type': 'multipart/form-data'}
    })
}
export function stop(params){
    return request({
        url: 'smartStop/stop.do?',
        method: 'post',
        data:params
    })
}

export function exportCardbusines(params){
    return request({
        url: 'smartStop/exportAllSync.do?',
        method: 'post',
        data:params
    })
}